import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import styles from './TopNRecordsLineGraph.module.css';
import MultiLineGraph from '../MultiLineGraph/MultiLineGraph';

const TopNRecordsLineGraph = ({
  data,
  maxRecordCount,
  isLoading,
  durationText,
  label,
}) => {
  if (isLoading) {
    return (
      <div className={styles.graphLoaderIcon}>
        <CircularProgress />
      </div>
    );
  } else {
    return (
      <MultiLineGraph
        data={data}
        maxRecordCount={maxRecordCount}
        durationText={durationText}
        label={label}
      />
    );
  }
};
export default TopNRecordsLineGraph;
